import "./App.css";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
// Material Kit 2 PRO React themes
import theme from "./assets/theme";
//Pages Import
import ErrorPage from "./error_/ErrorPage";
import ChangePasswordPage from "./pages/Authentication/ChangePassword";
import ResetPasswordPage from "./pages/Authentication/ResetPassword";
import ForgetPasswordPage from "./pages/Authentication/ForgetPassword";
import LandingPortal from "./pages/LandingPortal";
import FEMSDashboard from "./pages/FEMSDashboard";
import LoginPage from "./pages/Authentication/Login";
import constants from "./common/constants";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./redux/app/store";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./components/ProtectedRoute/index.js";
import axios from 'axios';

window.axiosVersion = axios.version || axios.VERSION;

function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={constants.googleRecaptcha.sitekey} useEnterprise={false} language="en" >
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ToastContainer
            position="bottom-left"
            autoClose={10000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
          <PersistGate loading={null} persistor={persistor}>
            <Routes>
              <Route path={constants.prefix_url} element={<LoginPage />} />
              <Route path={"/home"} element={<FEMSDashboard />} />
              <Route
                path={constants.prefix_url + "login"}
                element={<LoginPage />}
              />

              <Route path={"changepassword"} element={<ChangePasswordPage />} />
              <Route path={"forgetpassword"} element={<ForgetPasswordPage />} />
              <Route path={"resetpassword"} element={<ResetPasswordPage />} />
              <Route path={"/*"} element={<ErrorPage />} />
              <Route
                path={constants.ira_prefix_url + "resetpassword"}
                element={<ResetPasswordPage />}
              />
              <Route
                path={constants.prefix_url + "jtc/dashboard"}
                element={<LandingPortal />}
              />
              <Route
                path="/jmm/app/case/info"
                element={
                  <ProtectedRoute>
                    <></>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </PersistGate>
        </LocalizationProvider>
      </ThemeProvider>
    </GoogleReCaptchaProvider>
  );
}

export default App;
